/*
==========================================================
MODULES
==========================================================
*/

import platform from "./es/platform";
import auth from "./es/auth";
import superAdmin from "./es/superAdmin";
import roles from "./es/roles";
import modules from "./es/modules";

/*
==========================================================
SPANISH
==========================================================
*/

const es = {

  platform,

  auth,

  superAdmin,

  roles,

  modules

};

export default es;